export default "__VITE_ASSET__BrgPM8JP__"